import { TextId, useTextsV2 } from '../../utils/useTexts'
import { TdsModal, TdsSpinner } from '@scania/tegel-react'

export function ModalWaitingForExtendedCheck(): JSX.Element {
  const t2 = useTextsV2()
  return (
    <TdsModal size="md" header={t2(TextId.HEADER_WAIT)} show prevent={true}>
      <span slot="body">
        <TdsSpinner size="md" />
      </span>
    </TdsModal>
  )
}
